// extracted by mini-css-extract-plugin
export default {"dashboardNav":"DashboardNav_dashboardNav__rYN8J","hide":"DashboardNav_hide__6BxL8"};